export type SupportedLanguages = 'en' | 'de';
export const SUPPORTED_LANGUAGES: readonly SupportedLanguages[] = ['en', 'de'] as const;
export const DEFAULT_LANGUAGE: SupportedLanguages = 'de';
export const FALLBACK_LANGUAGE: SupportedLanguages = 'de';
